import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadProperties } from "../properties/loaders.ts";
import { NewPropertyPage } from "../properties/new-property-page.tsx";
import { FormPending } from "../shell/record-pending.tsx";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null ? <NoAccessPage /> : <NewPropertyPage viewer={viewer} />;
};

export const Route = createFileRoute("/_app/properties/new")({
  loader: async ({ context }) => loadProperties(context.data),
  pendingComponent: () => <FormPending hasSteps />,
  component: Page,
});
